import styled from 'src/styles/theme';
import { ModalShareOfferSummaryStyled } from '../ModalShareOfferSummaryStyled';

export const ModalShareOfferSummaryStyledOV = styled(ModalShareOfferSummaryStyled)``;
